import { Component} from '@angular/core';
import { NavController, ModalController,  MenuController, Platform, NavParams, ViewController } from 'ionic-angular';
import {AngularFireAuth} from 'angularfire2/auth';
import {LoginPage} from '../login/login';
import {AngularFireDatabase,  FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import {FilterPipe} from '../../models/sort';
import {ModalContentPage} from './modal';
import { CoolLocalStorage } from 'angular2-cool-storage';
import {Observable} from 'rxjs/Rx';
import {Subscription} from "rxjs";
import { RecordsPage } from '../records/records';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  questions: FirebaseListObservable<any[]>;
  cat: Array<any> = [];
  catChk: Array<Boolean> = [];
  dis: Array<String> = [];
  asked: Array<Boolean> = [];
  ready: Boolean = true;
  users: FirebaseListObservable<any[]>;
  board: FirebaseObjectObservable<any[]>;
  user: any;
  live: FirebaseObjectObservable<any[]>;
  game: FirebaseObjectObservable<any[]>;
  localStorage: CoolLocalStorage;
  clock: FirebaseObjectObservable<any[]>;
  timer: Subscription;
  repeater: number;
  stopclock: number;



  constructor( menuCtrl: MenuController, localStorage: CoolLocalStorage, public modalCtrl: ModalController, public params: NavParams, public navCtrl: NavController, private afauth: AngularFireAuth, private db: AngularFireDatabase) {

        menuCtrl.enable(true);

        const authObserver = afauth.authState.subscribe( user => {
          if (user == null) {
            this.navCtrl.setRoot(LoginPage);
            authObserver.unsubscribe();
          }
          else
          {


          this.localStorage = localStorage;


          this.questions = db.list('/questions', {query: {orderByChild : "cat"}});
          this.users = db.list('/v2/users/' + this.localStorage.getItem('code'));
          this.live = db.object('/v2/game/' + this.localStorage.getItem('code') + '/one/live');
          this.game  = db.object('/v2/game/' + this.localStorage.getItem('code'));
          this.clock = db.object('/v2/game/' + this.localStorage.getItem('code') + '/counter');
          this.board = db.object('/v2/scoreboard/' + this.localStorage.getItem('code'));


          db.object('/v2/game/' + this.localStorage.getItem('code') + '/count').subscribe(data =>
          {
              this.repeater = parseInt(data.$value);
          })






           db.list('/questions').subscribe(snapshots=>{
            snapshots.forEach(snapshot => {

              this.ready = false;
              if(!this.localStorage.getItem('ques'))
              {
                this.asked.push(false);
              }



                if(this.cat)
                {
                   var chk = this.cat.indexOf(snapshot.cat);


                   if(chk == -1)
                   {
                      this.cat.push(snapshot.cat);
                      this.catChk.push(false);
                      this.dis.push("ndisabled");

                   }

                }
                else
                {
                  this.cat.push(snapshot.cat);
                  this.catChk.push(false);
                  this.dis.push("ndisabled");

                }

            });
        })

        if(this.localStorage.getItem('ques'))
        {
          this.asked = JSON.parse(this.localStorage.getItem('ques'));
          console.log(this.asked)
        }
      }

    });




  }


 updateList(q, chked, index)
 {

    if(chked == true)
    {
      for(var i = 0; i < this.dis.length ; i++)
      {


         if(i != index)
         {
            this.dis[i] = "disabled";
         }

      }

      this.questions = this.db.list('/questions', {query: {orderByChild : "cat", equalTo : q }});
    }
    else
    {

        for(var i = 0; i < this.dis.length ; i++)
        {


           if(i != index)
           {
              this.dis[i] = "ndisabled";
           }

        }

        this.questions = this.db.list('/questions', {query: {orderByChild : "cat"}});
    }

 }



   goLive(q, i)
   {

        this.asked[i] = true;
        this.localStorage.setItem('ques', JSON.stringify(this.asked));
        this.board.set("null");
        this.live.set(q);
        var value = this.repeater;
        if(this.timer)
        {
          this.timer.unsubscribe();
        }
        let timer = Observable.timer(value, 1000);


        this.timer = timer.subscribe(t=> {this.qtime(t); });
   }

   qtime(t)
   {

     if(t <= this.repeater)
     {
        this.clock.set(t);
     }
     else
     {
        this.clock.set(0);
        this.timer.unsubscribe();

     }

   }

   record(key, name)
   {
     this.navCtrl.push(RecordsPage, {
       item: key,
       name: name
     });
   }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts